import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import AppRouteError from 'components/AppRouteError';

// jwt auth
const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const RegisterPage = Loadable(lazy(() => import('pages/auth/Register')));
const AcceptInvitePage = Loadable(lazy(() => import('pages/auth/AcceptInvite')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  errorElement: <AppRouteError />,
  children: [
    {
      path: '/',
      children: [
        {
          path: '/login',
          element: <LoginPage />
        },
        {
          path: '/register',
          element: <RegisterPage />
        },
        {
          path: '/accept-invite',
          element: <AcceptInvitePage />
        }
      ]
    }
  ]
};

export default LoginRoutes;
